export default "__VITE_ASSET__1bc08170__"